import { useState } from 'react'
import { Carousel } from 'react-bootstrap'
import { ModalIconHelpPlaySVG } from 'assets/svg/ModalSVG/ModalIconHelpPlaySVG'

function ContentModalHelp({ data }) {
	return (
		<Carousel wrap={true} controls={false} interval={null}>
			<Carousel.Item>
				<div className="box-item">
					{data.map((it, i) => {
						if (i < 3) {
							return (
								<div className="body-help-play">
									<img src={it.img} alt="" />
									<div className="text">
										<h5>{`ຂັ້ນຕອນ${i + 1}`}</h5>
										<ModalIconHelpPlaySVG
											width="18"
											height="4"
											viewBox="0 0 18 4"
										/>
										<p>{it.text}</p>
									</div>
								</div>
							)
						}
					})}
				</div>
			</Carousel.Item>
			<Carousel.Item>
				<div className="box-item">
					{data.map((it, i) => {
						if (i > 2) {
							return (
								<div className="body-help-play">
									<img src={it.img} alt="" />
									<div className="text">
										<h5>{`ຂັ້ນຕອນ${i + 1}`}</h5>
										<ModalIconHelpPlaySVG
											width="18"
											height="4"
											viewBox="0 0 18 4"
										/>
										<p>{it.text}</p>
									</div>
								</div>
							)
						}
					})}
				</div>
			</Carousel.Item>
		</Carousel>
	)
}

export default ContentModalHelp
